import React, { useState, useEffect } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { sortBy } from 'lodash';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-solid-svg-icons';

import AddPlugCustomTemplateModal from '../../modals/PlugCustomTemplateModals/AddPlugCustomTemplateModal';
import SmallerLoader from '../../SmallerLoader';
import PlugCustomTemplate from './PlugCustomTemplate';

const getStyles = (disabled) => {
  return {
    iconStyle: {
      fontSize: '21px',
      margin: '0.15em 0.25em 0em 0.25em',
      verticalAlign: 'text-bottom',
      cursor: disabled ? 'none' : 'pointer',
      color: 'var(--et_tab_grey)',
      opacity: disabled ? '0.5' : '1.0',
    },
  };
};

export default function PlugCustomTemplates(props) {
  const {
    organizationId,
    providerAccounts,
    templates,
    setTemplates,
    showToast,
  } = props;

  const [activeTemplateId, setActiveTemplateId] = useState(null);
  const [activeTemplate, setActiveTemplate] = useState(null);

  const [showAddModal, setShowAddModal] = useState(false);

  const [isSaving, setIsSaving] = useState(false);

  useEffect(() => {
    if (activeTemplateId !== null) {
      let temlpate = templates.find(
        (temlpate) => temlpate.id === activeTemplateId
      );
      setActiveTemplate(temlpate ? temlpate : null);
    } else {
      setActiveTemplate(null);
    }
  }, [templates, activeTemplateId]);

  return (
    <>
      <Row>
        <Col style={{ marginBottom: '0.5em' }} xs={12}>
          <Row style={{ padding: '1em 1em 0.5em 1em' }}>
            <Col style={{ display: 'inline-flex' }}>
              <Row>
                <Form inline style={{ marginBottom: '0.5em' }}>
                  <Form.Label
                    style={{
                      display: 'block',
                      marginRight: '0.5em',
                      marginLeft: '0.5em',
                    }}
                  >
                    Template:
                  </Form.Label>
                  <Form.Control
                    style={{ float: 'right' }}
                    as='select'
                    size='sm'
                    value={activeTemplateId ? activeTemplateId : ''}
                    onChange={(e) => {
                      let tid = e.target.value;
                      setActiveTemplateId(parseInt(tid));
                      setActiveTemplate(null);
                    }}
                  >
                    <option hidden value={'null'} key={'null-opt'}>
                      Select a template
                    </option>
                    {templates.length === 0 && (
                      <option disabled value={'dis'} key={'null-dis'}>
                        No Templates
                      </option>
                    )}
                    {sortBy(templates, ['name']).map((temlpate) => (
                      <option
                        key={`temlpate-opt-${temlpate.id}-${temlpate.temlpate_type}`}
                        value={temlpate.id}
                      >
                        {temlpate.name}
                      </option>
                    ))}
                  </Form.Control>
                </Form>
                <FontAwesomeIcon
                  style={getStyles(isSaving).iconStyle}
                  icon={faPlus}
                  title={'Add Template'}
                  disabled={isSaving}
                  onClick={() => {
                    if (!isSaving) {
                      setShowAddModal(true);
                    }
                  }}
                />

                {isSaving && (
                  <div style={{ marginTop: '4px' }}>
                    <SmallerLoader style={{ fontSize: '18px' }} />
                  </div>
                )}
              </Row>
            </Col>
          </Row>
          <Row style={{ padding: '0em 2em' }}>
            {activeTemplateId !== null && activeTemplate !== null && (
              <PlugCustomTemplate
                activeTemplate={activeTemplate}
                setTemplates={setTemplates}
                providerAccounts={providerAccounts}
                organizationId={organizationId}
                showToast={showToast}
                isSaving={isSaving}
                setIsSaving={setIsSaving}
              />
            )}
          </Row>
        </Col>
      </Row>
      <AddPlugCustomTemplateModal
        show={showAddModal}
        onHide={() => {
          setShowAddModal(false);
        }}
        showToast={showToast}
        setTemplates={setTemplates}
        setActiveTemplateId={setActiveTemplateId}
        organizationId={organizationId}
      />
    </>
  );
}
